import { render, staticRenderFns } from "./indexHistoriaMenstrual.vue?vue&type=template&id=5efe41e4"
import script from "./indexHistoriaMenstrual.vue?vue&type=script&lang=js"
export * from "./indexHistoriaMenstrual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports